/* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export interface AvatarJpgParticipantMap {
    '403': Status403;
    '404': Status404;
}
export interface Status403 {
    /**
     * Status of the response, eg. success.
     */
    status: 'success' | 'failed';
    result: 'Invalid token';
}
export interface Status404 {
    /**
     * Status of the response, eg. success.
     */
    status: 'failed';
    /**
     * We cant find the url of the user profile
     */
    result: 'No image available';
}

import {validate403, validate404} from './avatarJpgParticipantValidation';
type AvatarJpgParticipantResponse =
    | {status: 403; data: AvatarJpgParticipantMap['403']}
    | {status: 404; data: AvatarJpgParticipantMap['404']};
interface AvatarJpgParticipantParams {
    conferenceAlias: string;
    participantUuid: string;
}
export async function avatarJpgParticipant({
    fetcher,
    params,
    host,
}: {
    fetcher: typeof fetch;
    params: AvatarJpgParticipantParams;
    host: string;
}): Promise<AvatarJpgParticipantResponse> {
    const res = await fetcher(
        `${host}/api/client/v2/conferences/${params.conferenceAlias}/participants/${params.participantUuid}/avatar.jpg`,
        {
            method: 'get',
        },
    );
    if (res.status === 403) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Next line is validation
        const data = await res.json();
        if (!validate403(data)) {
            throw new Error(JSON.stringify(validate403.errors));
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Already validated
        return {status: res.status, data};
    }
    if (res.status === 404) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Next line is validation
        const data = await res.json();
        if (!validate404(data)) {
            throw new Error(JSON.stringify(validate404.errors));
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Already validated
        return {status: res.status, data};
    } else {
        throw new Error(`Unexpected status ${res.status}`);
    }
}
